import dayjs from 'dayjs'
import ExportCsvButton from '../Datacenter/ExportCsvButton'
import { dashboardReportName, financialsExportColumns, financialsExportRows } from './dashboardExport'
import { DashboardFilters } from './dashboardModel'
import { useFinancialsData } from './dashboardQueries'

type Props = {
  starting: string
  ending: string
  filters: DashboardFilters
}

const FinancialsExportButton = ({ starting, ending, filters }: Props) => {
  const financialsQuery = useFinancialsData(starting, ending, filters)

  return <ExportCsvButton
    reportName={dashboardReportName('Job Costing', filters)}
    dateRange={{ start: dayjs(starting), end: dayjs(ending) }}
    columns={financialsExportColumns}
    // While new filters load the card keeps the previous numbers on screen; don't export them as the new ones.
    rows={financialsQuery.isPreviousData ? [] : financialsExportRows(financialsQuery.data)}
  />
}

export default FinancialsExportButton
